import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import { useL10n } from '@uplift/hooks';


const useEmptyActionItemStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    padding: theme.spacing(3),
    paddingTop: theme.spacing(3.5),
  },
  icon: {
    fontSize: '60px',
    color: '#D5D2C7',
    marginRight: theme.spacing(3.5),
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  title: {
    fontWeight: 600,
  },
  subtitle: {
    marginTop: theme.spacing(0.5),
  }
}));

export type EmptyActionItemProps = {
  title?: string;
};

export const EmptyActionItem: React.FC<EmptyActionItemProps> = ({ title }) => {
  const l10n = useL10n();
  const { classes } = useEmptyActionItemStyles();

  return (
    <Paper>
      <Box className={classes.root}>
        <CheckCircleOutline className={classes.icon} />
        <Box className={classes.content}>
          <Typography variant="body1" className={classes.title}>{title ?? l10n.dashboard.actionItems.empty.title}</Typography>
          <Typography variant="body1" className={classes.subtitle}>{l10n.dashboard.actionItems.empty.subtitle}</Typography>
        </Box>
      </Box>
    </Paper>
  );
};